import { createSlice, current } from "@reduxjs/toolkit";

export const AnswerReducer = createSlice({
  name: "Quiz",
  initialState: [],
  reducers: {
    addAnswer: (state, action) => {
      const allAnswer = current(state);
      const answerObj = [...allAnswer];
      const EditIndex = allAnswer.findIndex(
        (item) => item.question_id === action.payload.question_id
      );
      if (EditIndex !== -1) {
        answerObj[EditIndex] = {
          question_id: action.payload.question_id,
          answer_id: action.payload.answer_id,
          timeStart: action.payload.timeStart,
          timeEnd: action.payload.timeEnd,
        };
        return answerObj;
      } else {
        return [...state, action.payload];
      }
    },
  },
});
export const { addAnswer } = AnswerReducer.actions;
export default AnswerReducer.reducer;
